import React from "react";
import { Card } from "react-bootstrap";
export function EditSection({
    children,
    title,
    mt,
    ml,
    mb,
    childrenStyles,
    style = {},
    hasButton = false,
    button = <></>,
}) {
    return (
        <>
            <div className={`mb-${mb ? mb : "4"} `} style={style}>
                <Card.Title className="d-inline" style={{ color: '#777777' }}>
                    {title}
                </Card.Title>
                <div className="float-right">{hasButton && button}</div>
            </div>

            <div
                className={`ml-${ml ? ml : "0"} mb-${mb ? mb : "0"}`}
                style={childrenStyles}
            >
                {children}
            </div>
        </>
    );
}
